import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GlobalSidenavService {
  protected isSideNavOpen = new BehaviorSubject<boolean>(true);
  protected renderNav = new BehaviorSubject<boolean>(true);
  public isSideNavOpen$: Observable<boolean> = this.isSideNavOpen.asObservable().pipe(distinctUntilChanged(), shareReplay(1));
  public renderNav$: Observable<boolean> = this.renderNav.asObservable().pipe(distinctUntilChanged(), shareReplay(1));
  public toggle() {
    this.isSideNavOpen.next(!this.isSideNavOpen.getValue());
  }

  setSideNavState(state: boolean) {
    this.isSideNavOpen.next(state);
  }

  public open() {
    return this.isSideNavOpen.next(true);
  }

  public close() {
    return this.isSideNavOpen.next(false);
  }

  public render() {
    return this.renderNav.next(true);
  }

  public doNotRender() {
    return this.renderNav.next(false);
  }
}
